import { useContext } from 'react';

import { CharlieTableContext } from './CharlieTableContext';

export type PaginationIncrementProps = {
	endPage: string | null;
};

export type PaginationDecrementProps = {
	handlePagination: (pageCursor: string | null) => void;
};

export const usePaginationConfig = () => {
	const { pushPageCursor, popPageCursor, resetPageCursors, currentPage, pageSize, updatePageSize } =
		useContext(CharlieTableContext);

	const handlePageIncrement = ({ endPage }: PaginationIncrementProps) => {
		pushPageCursor(endPage || '');
	};

	const handlePageDecrement = () => {
		popPageCursor();
	};

	const handlePaginationReset = () => {
		resetPageCursors();
	};

	const handleUpdatePageSize = (newPageSize: number) => {
		updatePageSize(newPageSize);
	};

	return {
		currentPage,
		pageSize,
		handlePageDecrement,
		handlePageIncrement,
		handlePaginationReset,
		handleUpdatePageSize,
	};
};
